/**
 * Roadmap and the loved one's Journey are two views of the same data:
 * Roadmap = "Where are we going?" · Journey = "How did we get here?"
 */
import React from "react";
import { Link } from "react-router-dom";
import { Map, BookHeart } from "lucide-react";

export const JourneyViewToggle = ({ active, first }) => {
    const base = "inline-flex items-center gap-1.5 rounded-2xl px-4 py-2 text-sm font-semibold transition-colors focus-visible:ring-2 focus-visible:ring-teal outline-none";
    const on = "bg-teal-dark text-white";
    const off = "text-[#4C5551] hover:bg-cream-light";
    return (
        <div className="inline-flex rounded-full border border-cream-dark bg-white p-1 shadow-sm" data-testid="journey-view-toggle" role="tablist">
            <Link to="/roadmap" data-testid="journey-toggle-roadmap" role="tab" aria-selected={active === "roadmap"}
                className={`${base} ${active === "roadmap" ? on : off}`}>
                <Map size={14} strokeWidth={2} /> Roadmap
            </Link>
            <Link to="/roadmap/story" data-testid="journey-toggle-story" role="tab" aria-selected={active === "story"}
                className={`${base} ${active === "story" ? on : off}`}>
                <BookHeart size={14} strokeWidth={2} /> {first ? `${first}'s Journey` : "Their Journey"}
            </Link>
        </div>
    );
};
